import styled from 'styled-components'

import background from 'assets/background.png'

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url(${background}) no-repeat top right;

  .mobile_container {
    margin: 4rem;
    width: 45rem;
    height: auto;
    background-color: white;
    box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.2);
    border-radius: 0.8rem;
    padding: 2rem;
    padding-top: 0;
    position: relative;
  }

  .full_width {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    &__logo {
      height: 4rem;
      margin-bottom: 2rem;
    }
  }

  .main {
    .not_supported {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      font-weight: 700;
      text-align: center;
      margin-top: 4rem;
      color: ${(props) => props.theme.palette.gray[600]};

      svg {
        color: ${(props) => props.theme.palette.gray[300]};
        width: 10rem;
        height: 10rem;
        margin-bottom: 3rem;
      }

      small {
        margin-top: 2rem;
        font-size: 1.6rem;
        font-weight: 600;
        color: ${(props) => props.theme.palette.gray[500]};
      }
    }

    .desktop_warning {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h3 {
        font-size: 2.6rem;
        text-transform: uppercase;
        color: ${(props) => props.theme.palette.primary};
        margin-bottom: 2rem;
      }

      svg {
        color: ${(props) => props.theme.palette.gray[300]};
        width: 10rem;
        height: 10rem;
        margin-bottom: 3rem;
      }

      p {
        font-size: 1.6rem;
        text-align: center;
        color: ${(props) => props.theme.palette.gray[600]};
        margin-bottom: 3rem;
      }
    }
  }
`
